import { createRoot } from "react-dom/client";
import { i18nReady } from "./i18n";
import App from "./App.tsx";
import "./index.css";

void i18nReady.finally(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});
